import { MainContext } from "../../Context";
import React, { useContext } from "react";

const LandingBanner = () => {
  const setting = useContext(MainContext);

  // ===================================================================================================

  return (
    <section className="pt-4 pb-0 card-grid">
      <div className="container">
        <div className="row g-4">
          <div className="col-lg-6">
            <div
              className="card card-overlay-bottom card-grid-lg card-bg-scale"
              style={{
                backgroundImage: `url(${setting.setting.first_image})`,
                backgroundPosition: "center",
                backgroundSize: "cover",
              }}
            >
              <div className="card-img-overlay d-flex align-items-center p-3 p-sm-4">
                <div className="w-100 mt-auto">
                  <h1 className="text-white">{setting.setting.first_title}</h1>
                </div>
              </div>
            </div>
          </div>

          <div className="col-lg-6">
            <div className="row g-4">
              <div className="col-12">
                <div
                  className="card card-overlay-bottom card-grid-sm card-bg-scale"
                  style={{
                    backgroundImage: `url(${setting.setting.second_image})`,
                    backgroundPosition: "center",
                    backgroundSize: "cover",
                  }}
                >
                  <div className="card-img-overlay d-flex align-items-center p-3">
                    <div className="w-100 mt-auto">
                      <h4 className="text-white">
                        {setting.setting.second_title}
                      </h4>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-md-6">
                <div
                  className="card card-overlay-bottom card-grid-sm card-bg-scale"
                  style={{
                    backgroundImage: `url(${setting.setting.third_image})`,
                    backgroundPosition: "center",
                    backgroundSize: "cover",
                  }}
                >
                  <div className="card-img-overlay d-flex align-items-center p-3">
                    <div className="w-100 mt-auto">
                      <h4 className="text-white">
                        {setting.setting.third_title}
                      </h4>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-md-6">
                <div
                  className="card card-overlay-bottom card-grid-sm card-bg-scale"
                  style={{
                    backgroundImage: `url(${setting.setting.forth_image})`,
                    backgroundPosition: "center",
                    backgroundSize: "cover",
                  }}
                >
                  <div className="card-img-overlay d-flex align-items-center p-3">
                    <div className="w-100 mt-auto">
                      <h4 className="text-white">
                        {setting.setting.forth_title}
                      </h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LandingBanner;
